import { notify } from '@bynder/design-system';

export const teaErrorNotifier = (error: Error) => {
  console.error(error);
  return notify({
    variant: 'error',
    title: 'Something went wrong',
  });
};
